export default __webpack_public_path__ + "static/media/icn_complete.d23bdd7a.svg";